

















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import TaskTemplatesRepository from '@/modules/tasks/templates/TaskTemplatesRepository';
import EmployeesRepository from '@/modules/employees/employeesRepository';
import Datagrid from '@/components/default/Datagrid.vue';
import { DxNavBar } from 'devextreme-vue';
import { SecurityConfig } from '@/installationConfig';

@Component({
  components: {
    Datagrid,
    DxNavBar,
  },
})
export default class TaskTemplatesTable extends Vue {
  employees: any[] = [];
  loading: boolean = false;
  items: ITaskTemplateDto[] = [];

  created() {
    this.loadData();
    this.loadEmployees();
  }

  async loadEmployees() {
    try {
      this.employees = (await EmployeesRepository.get()).data;
    } catch {
      notificationService.showErrorMessage('Mislukt om de werknemers te laden!');
    }
  }

  async loadData() {
    try {
      this.loading = true;
      this.items = (await TaskTemplatesRepository.getAll()).data;
    } catch {
      notificationService.showErrorMessage('Mislukt om de templates te laden!');
    } finally {
      this.loading = false;
    }
  }

  refresh() {
    try {
      ((this.$refs.rentalGrid as Datagrid).$refs.taskTemplatesGrid as any).instance.refresh();
    } catch {
      notificationService.showErrorMessage('Mislukt om de grid te refreshen!');
    }
  }

  editRow(e: any) {
    if (e && e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons') {
      this.$router.push({ path: `/tasks/templates/${e.data.id}` });
    }
  }

  async deleteRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        await TaskTemplatesRepository.delete(e.data.id);
        notificationService.saved();
        resolve(false);
      } catch (err) {
        notificationService.showAxiosError(err);
        resolve(true);
      }
    });
  }

  addTemplate() {
    this.$router.push({ path: `/tasks/templates/create` });
  }

  get columns() {
    const self = this;
    return [
      {
        dataField: 'name',
        caption: 'Naam',
      },
      {
        dataField: 'team',
        caption: 'Team',
        lookup: {
          items: [
            { value: SecurityConfig.administratorGroup, text: 'Admin' },
            { value: SecurityConfig.administrationGroup, text: 'Administratie' },
            { value: SecurityConfig.calculatorGroup, text: 'Calculators' },
            { value: SecurityConfig.hrGroup, text: 'Human Resources' },
            { value: SecurityConfig.projectCoordinatorGroup, text: 'Project Coördinator' },
            { value: SecurityConfig.qualityGuardGroup, text: 'Quality Guards' },
            { value: SecurityConfig.qualityGuardOneSkinGroup, text: 'Quality Guards (OneSkin)' },
          ],
          valueExpr: 'value',
          displayExpr: 'text',
        },
      },
      {
        dataField: 'assignedUserId',
        caption: 'Gebruiker',
        lookup: {
          items: this.employees,
          valueExpr: 'adUserId',
          displayExpr: 'displayName',
        },
      },
      {
        type: 'buttons',
        buttons: ['edit', 'delete'],
      },
    ];
  }

  get toolbarOptions() {
    const self = this;

    return [
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'fas fa-plus',
          text: 'Toevoegen',
          stylingMode: 'outlined',
          type: 'success',
          onClick: this.addTemplate,
        },
      },
    ];
  }
}
